import React from 'react';
import _ from 'lodash';
import Moment from 'moment';

import { FieldContractorUserService } from '../../services/FieldContractorUsers';
import { CompanyBranchService } from '../../services/CompanyBranches';
import { FieldGroupService } from '../../services/FieldGroups';
import { FieldItemService } from '../../services/FieldItems';
import { SafetyDiaryService } from '../../services/SafetyDiaries';
import FieldItemInputsService from '../../services/FieldItemInputs';
import {
  REQUEST_PARAMS,
  FLAG_STAUS,
  SAFETY_TYPE,
} from '../../utilities/constants';
import SafetyDiariesConstants from '../../utilities/safetyDiariesConstants';
import { isNullOrEmpty } from '../../utilities/stringUtil';
import {
  FormElement,
  FormList,
  FormListItem,
  FormListItemChild,
  FormListItemGroup,
} from '../CommonFormComponents';

// form specified constants
// Form fields
const fieldNames = {
  IMAGE: 0,
  REPORT_DATE: 1,
  REPORTER: 2,
  REPORT_DESCRIPTION: 3,
  REPORT_TYPE: 4,
  REPORT_LIMIT: 5,
  PRIORITY: 6,
  FIELD_A_ITEM: 7,
  FIELD_B_ITEM: 8,
  FIELD_C_ITEM: 9,
  FIELD_D_ITEM: 10,
  PATROL: 11,
  NOTIFICATION: 12,
  ADDRESS: 13,
  SAFETY_DIARY: 14,
  NOTIFICATION_TGT: 15,
};

const report_type = [
  { id: '1', name: '指摘(巡回)' },
  { id: '2', name: '周知(巡回)' },
  { id: '3', name: 'その他(巡回)' },
  { id: '4', name: '当日作業連絡' },
  { id: '5', name: 'その他連絡' },
];

const ReportType = {
  POINTED_OUT: 1,
  INFORM: 2,
  OTHERS: 3,
  WORK_COMMUNICATION: 4,
  OTHER_COMMUNICATION: 5,
};

const Urgency = [
  { id: '1', name: '低' },
  { id: '2', name: '中' },
  { id: '3', name: '高' },
  { id: '4', name: '緊急' },
];

// Form schema
const schemas = {
  pointed_out: [
    fieldNames.PATROL,
    fieldNames.PRIORITY,
    fieldNames.REPORT_DESCRIPTION,
    fieldNames.FIELD_ITEM,
    fieldNames.NOTIFICATION,
    fieldNames.NOTIFICATION_TGT,
    fieldNames.SAFETY_DIARY,
  ],
  inform: [
    fieldNames.PATROL,
    fieldNames.REPORT_LIMIT,
    fieldNames.PRIORITY,
    fieldNames.REPORT_DESCRIPTION,
    fieldNames.FIELD_ITEM,
    fieldNames.NOTIFICATION,
    fieldNames.SAFETY_DIARY,
  ],
  others: [
    fieldNames.PATROL,
    fieldNames.PRIORITY,
    fieldNames.REPORT_DESCRIPTION,
    fieldNames.FIELD_ITEM,
    fieldNames.SAFETY_DIARY,
  ],
  work_communication: [
    fieldNames.PRIORITY,
    fieldNames.REPORT_DESCRIPTION,
    fieldNames.FIELD_ITEM,
    fieldNames.NOTIFICATION,
    fieldNames.SAFETY_DIARY,
  ],
  other_communication: [
    fieldNames.PATROL,
    fieldNames.PRIORITY,
    fieldNames.REPORT_DESCRIPTION,
    fieldNames.FIELD_ITEM,
    fieldNames.SAFETY_DIARY,
  ],
};

export const SafetyDiaryConfirmFormData = {
  journal_type: '', // 記入者
  entries_date: Moment().format('YYYY/MM/DD'), // 記入日
  patrol: '',
  type: '1', // 種別
  urgency: '1', // 緊急度
  a_item_id: '',
  b_item_id: '',
  c_item_id: '',
  d_item_id: '',
  area_detail: '', // 詳細場所
  pointing_out_detail: '',
  image1: '',
  image2: '',
  image3: '',
  image4: '',
  notifications_company_flag: '0',
  notifications_manager_flag: '0',
  notifications_group_flag: '0',
  print_diary_flag: '0',
  end_date: Moment().format('YYYY/MM/DD'), //周知期限
  create_user_name: '',
  update_user_name: '',
};

export class SafetyDiaryConfirmForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fieldId: props.fieldId || sessionStorage.getItem('field_id'),
      formData: SafetyDiaryConfirmFormData,
      managers: [], // 通知対象 (現場監督)
      companies: [], // 通知対象 (協力会社)
      groups: [], // 通知対象 (グループ))
      notificationList: [], // 通知リスト
      preview: this.props.preview || false,
      itemNames: { A: '', B: '', C: '', D: '' },
      aItemName: '',
      bItemName: '',
      cItemName: '',
      dItemName: '',
    };

    this.fields = [
      { name: fieldNames.IMAGE, field: this.renderPatrolImageField },
      { name: fieldNames.REPORT_DATE, field: this.renderReportDateField },
      { name: fieldNames.REPORTER, field: this.renderReporterField },
      {
        name: fieldNames.REPORT_DESCRIPTION,
        field: this.renderReportDescrtiptionField,
      },
      { name: fieldNames.REPORT_TYPE, field: this.renderReportTypeField },
      { name: fieldNames.REPORT_LIMIT, field: this.renderReportLimitField },
      { name: fieldNames.PRIORITY, field: this.renderUrgencyField },
      { name: fieldNames.PATROL, field: this.renderPatrolField },
      { name: fieldNames.FIELD_ITEM, field: this.renderFieldItem },
      { name: fieldNames.SAFETY_DIARY, field: this.renderSafetyDiaryField },
      { name: fieldNames.NOTIFICATION, field: this.renderNotificationField },
    ];
  }

  setNotificationList(formData) {
    const notificationList = [];

    const getNotificationListForManager = () => {
      const notification = {
        title: '現場監督',
        value: formData.notification_manager
          .map(element => element.name)
          .join(' / '),
      };
      notificationList.push(notification);
    };
    const getNotificationListForCompany = () => {
      const notification = {
        title: '協力会社',
        value: formData.notification_field_tree
          .map(element => element.name)
          .join(' / '),
      };
      notificationList.push(notification);
    };
    const getNotificationListForGroup = () => {
      const notification = {
        title: 'グループ',
        value: formData.notification_group
          .map(element => element.name)
          .join(' / '),
      };
      notificationList.push(notification);
    };

    if (formData.type === SAFETY_TYPE.point_out.id) {
      // 指摘(巡回) の場合、flagに関係なく表示（V1データーへの配慮）
      if (
        formData.notification_manager &&
        formData.notification_manager.length > 0
      ) {
        getNotificationListForManager();
      }
      if (
        formData.notification_field_tree &&
        formData.notification_field_tree.length > 0
      ) {
        getNotificationListForCompany();
      }
      if (
        formData.notification_group &&
        formData.notification_group.length > 0
      ) {
        getNotificationListForGroup();
      }
    } else {
      // 既存の仕様
      if (formData.notifications_manager_flag === FLAG_STAUS.positive.id) {
        getNotificationListForManager();
      }
      if (formData.notifications_company_flag === FLAG_STAUS.positive.id) {
        getNotificationListForCompany();
      }
      if (formData.notifications_group_flag === FLAG_STAUS.positive.id) {
        getNotificationListForGroup();
      }
    }

    return notificationList;
  }

  componentDidMount() {
    FieldContractorUserService.list(this.state.fieldId, { role_code: 4 }).then(
      response => {
        if (!response.result) {
          return;
        }
        const data = response.data.entities.field_contractor_users;
        const contractors = _.map(data, fieldContractor => {
          return {
            id: fieldContractor.id,
            name: fieldContractor.user_name,
          };
        });
        this.setState({ managers: contractors });
      }
    );
    CompanyBranchService.companyPartnerList({
      field_id: this.state.fieldId,
      limit: REQUEST_PARAMS.parentLimit,
    }).then(response => {
      if (!response.result) {
        return;
      }
      const data = response.data.entities.company;
      const companies = _.map(data, company => {
        return { id: company.id, name: company.name };
      });
      this.setState({ companies });
    });

    FieldGroupService.list(this.state.fieldId, {}).then(response => {
      if (!response.result) {
        return;
      }
      const data = response.data.entities.field_groups;
      const groups = _.map(data, group => {
        return { id: group.id, name: group.name };
      });
      this.setState({ groups });
    });

    FieldItemInputsService.itemNames(this.state.fieldId).then(itemNames =>
      this.setState({ itemNames })
    );

    // 更新時
    if (this.props.dataId !== '0' && !isNullOrEmpty(this.props.dataId)) {
      this.loadDiary(this.props.dataId);
    }
  }

  loadDiary = dataId => {
    const params = this.props.params || {
      date_type: SafetyDiariesConstants.dataType.entriesDate,
    };
    // APIから取得
    SafetyDiaryService.getDiary(this.state.fieldId, dataId, params).then(
      response => {
        const safetyDiary = response.data.entities.safety_diary;
        this.setState({ formData: safetyDiary });

        if (safetyDiary.a_item_id) {
          FieldItemService.show(this.state.fieldId, safetyDiary.a_item_id).then(
            response => {
              this.setState({
                aItemName: response.data.entities.field_item_list.name,
              });
            }
          );
        }

        if (safetyDiary.b_item_id) {
          FieldItemService.show(this.state.fieldId, safetyDiary.b_item_id).then(
            response => {
              this.setState({
                bItemName: response.data.entities.field_item_list.name,
              });
            }
          );
        }

        if (safetyDiary.c_item_id) {
          FieldItemService.show(this.state.fieldId, safetyDiary.c_item_id).then(
            response => {
              this.setState({
                cItemName: response.data.entities.field_item_list.name,
              });
            }
          );
        }

        if (safetyDiary.d_item_id) {
          FieldItemService.show(this.state.fieldId, safetyDiary.d_item_id).then(
            response => {
              this.setState({
                dItemName: response.data.entities.field_item_list.name,
              });
            }
          );
        }
      }
    );
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.dataId !== this.props.dataId &&
      !isNullOrEmpty(this.props.dataId)
    ) {
      this.loadDiary(this.props.dataId);
    }
    if (prevState.formData !== this.state.formData) {
      this.props.onUpdate(this.state.formData);
    }
  }

  renderPatrolImages() {
    const images = [];
    for (let i = 1; i <= 4; i++) {
      const targetImage = this.state.formData[`image_url${i}`];
      if (targetImage) {
        images.push(
          <div key={`img-patrol-${i}`} className='img-patrol'>
            <div className='img-patrol__inner'>
              <img src={targetImage} alt={i} />
            </div>
          </div>
        );
      }
    }
    return images;
  }

  renderPatrolImageField = images => {
    return (
      <div className='patrol-image'>
        {!_.isEmpty(images) && (
          <div className='patrol-image__image'>{images}</div>
        )}
      </div>
    );
  };

  /**
   * 記入日のコンポーネント
   *
   * @memberof SafetyDiaryConfirmForm
   */
  renderReportDateField = () => {
    return (
      <FormListItem label='記入日'>
        <FormElement>{this.state.formData.entries_date}</FormElement>
      </FormListItem>
    );
  };

  /**
   * 記入者のコンポーネント
   *
   * @memberof SafetyDiaryConfirmForm
   */
  renderReporterField = () => {
    let journalTypeName;

    const formDataJournalType = this.state.formData.journal_type;

    if (formDataJournalType) {
      // 元請け系と元請け系ではないのを複合した記入者のプルダウンリスト(immutable/非破壊)
      const mergedJournalType = {
        ...SafetyDiariesConstants.journalType,
        ...SafetyDiariesConstants.foremanJournalType,
      };

      const journalType = _.find(
        mergedJournalType,
        obj => obj.id === formDataJournalType
      );

      journalTypeName = journalType ? journalType.name : '';
    }

    return (
      <FormListItem label='記入者'>
        <FormElement>{journalTypeName}</FormElement>
      </FormListItem>
    );
  };

  renderReportTypeField = () => {
    let reportTypeName;

    if (this.state.formData.type) {
      const reportType = _.find(
        report_type,
        obj => obj.id === String(this.state.formData.type)
      );
      reportTypeName = reportType ? reportType.name : '';
    }

    return (
      <FormListItem label='種別'>
        <FormElement>{reportTypeName}</FormElement>
      </FormListItem>
    );
  };

  renderPatrolField = () => {
    return (
      <FormListItem label='巡回パトロール'>
        <FormElement>{this.state.formData.patrol}</FormElement>
      </FormListItem>
    );
  };

  renderReportLimitField = () => {
    return (
      <FormListItem label='周知期限'>
        <FormElement>{this.state.formData.end_date}</FormElement>
      </FormListItem>
    );
  };

  renderUrgencyField = () => {
    let urgencyName;

    if (this.state.formData.urgency) {
      const urgency = _.find(
        Urgency,
        u => u.id === String(this.state.formData.urgency)
      );
      urgencyName = urgency ? urgency.name : '';
    }

    return (
      <FormListItem label='緊急度'>
        <FormElement>{urgencyName}</FormElement>
      </FormListItem>
    );
  };

  renderReportDescrtiptionField = () => {
    return (
      <FormListItem label='内容'>
        <FormElement>{this.state.formData.pointing_out_detail}</FormElement>
      </FormListItem>
    );
  };

  renderFieldItem = () => {
    return (
      <FormListItem label='場所'>
        <div className='form-list__field-item'>
          {this.state.aItemName.trim() && (
            <FormElement>{this.state.aItemName}</FormElement>
          )}
          {this.state.bItemName.trim() && (
            <FormElement>{this.state.bItemName}</FormElement>
          )}
          {this.state.cItemName.trim() && (
            <FormElement>{this.state.cItemName}</FormElement>
          )}
          {this.state.dItemName.trim() && (
            <FormElement>{this.state.dItemName}</FormElement>
          )}
          {this.state.formData.area_detail.trim() && (
            <FormElement>{this.state.formData.area_detail}</FormElement>
          )}
        </div>
      </FormListItem>
    );
  };

  renderNotificationField = () => {
    const notificationList = this.setNotificationList(this.state.formData);
    return (
      <React.Fragment>
        <FormListItem label='通知対象' isBorder={!notificationList.length} />
        {notificationList.length > 0 && (
          <FormListItemGroup isBorder={false}>
            {notificationList.map((notification, i) => {
              return (
                <React.Fragment key={i}>
                  {this.renderNotificationTargetSelector(notification)}
                </React.Fragment>
              );
            })}
          </FormListItemGroup>
        )}
      </React.Fragment>
    );
  };

  renderNotificationTargetSelector = notification => {
    return (
      <FormListItemChild label={notification.title}>
        <FormElement>{notification.value}</FormElement>
      </FormListItemChild>
    );
  };

  renderSafetyDiaryField = () => {
    return (
      <FormListItem label='安全衛生日誌'>
        <FormElement>
          {this.state.formData.print_diary_flag === 1
            ? '反映する'
            : '反映しない'}
        </FormElement>
      </FormListItem>
    );
  };

  renderField(name) {
    const f = _.find(this.fields, field => {
      return field.name === name;
    });
    if (!f) {
      return null;
    }
    return f.field();
  }

  schemaByReportType(type) {
    switch (parseInt(type)) {
      case ReportType.POINTED_OUT:
        return schemas.pointed_out;
      case ReportType.INFORM:
        return schemas.inform;
      case ReportType.OTHERS:
        return schemas.others;
      case ReportType.WORK_COMMUNICATION:
        return schemas.work_communication;
      case ReportType.OTHER_COMMUNICATION:
        return schemas.other_communication;
      default:
        return [];
    }
  }

  renderCreateUserField = () => {
    return (
      <FormListItem label='登録者'>
        <FormElement>{this.state.formData.create_user_name}</FormElement>
      </FormListItem>
    );
  };

  renderCreateTimeField = () => {
    return (
      <FormListItem label='登録日時'>
        <FormElement>
          {this.state.formData.created_at !== null &&
          this.state.formData.create_user_name
            ? Moment(this.state.formData.created_at).format(
                'YYYY/MM/DD(ddd) HH:mm:ss'
              )
            : ''}
        </FormElement>
      </FormListItem>
    );
  };

  renderUpdateUserField = () => {
    return (
      <FormListItem label='最終更新者'>
        <FormElement>{this.state.formData.update_user_name}</FormElement>
      </FormListItem>
    );
  };

  renderContentUpdateTimeField = () => {
    return (
      <FormListItem label='最終更新日時'>
        <FormElement>
          {this.state.formData.content_update_time !== null &&
          this.state.formData.update_user_name
            ? Moment(this.state.formData.content_update_time).format(
                'YYYY/MM/DD(ddd) HH:mm:ss'
              )
            : ''}
        </FormElement>
      </FormListItem>
    );
  };

  render() {
    const images = this.renderPatrolImages();
    return (
      <div
        className={`SafetyDiaries__items ${
          this.props.isSpace ? 'SafetyDiaries__items--space' : ''
        }`}
      >
        {!_.isEmpty(images) && (
          <div className='SafetyDiaries__items-left'>
            {this.renderPatrolImageField(images)}
          </div>
        )}
        <div
          className={`SafetyDiaries__items-right ${
            _.isEmpty(images) ? 'SafetyDiaries__items-right--no-image' : ''
          }`}
        >
          <form>
            <FormList>
              {this.renderReportDateField()}
              {this.renderReporterField()}
              {this.renderReportTypeField()}

              {_.map(
                this.schemaByReportType(this.state.formData.type),
                (fieldItem, index) => {
                  return (
                    <React.Fragment key={`form-list__item-${index}`}>
                      {this.renderField(fieldItem)}
                    </React.Fragment>
                  );
                }
              )}
              {this.props.dataId !== '0' && this.props.dataId && (
                <React.Fragment>
                  {this.renderCreateUserField()}
                  {this.renderCreateTimeField()}
                  {this.renderUpdateUserField()}
                  {this.renderContentUpdateTimeField()}
                </React.Fragment>
              )}
            </FormList>
          </form>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/forms/SafetyDiaryConfirmForm.jsx